<docs>
# RadioButton

> NOTE: this docs defined at **docs** section inside RadioButton.vue module

RadioButton UI Set

<!-- STORY -->

### Example

>Single

```html
<mt-radio-button id="item-0" label="checked item" :checked="true"  />
<mt-radio-button id="item-1" label="unchecked item" :checked="false"  />
```

>Group

```html
<mt-radio-button type="group" v-for="item in items" :key="item.id" :id="item.id" :label="item.item" :checked="item.checked"  />
```

>Disabled

```html
<mt-radio-button id="item-0" label="disabled checked item" :checked="true" :disabled="true"  />
<mt-radio-button id="item-1" label="disabled unchecked item" :checked="false" :disabled="true"  />
```


### Props

| Property    | Description         | Type           | Accepted Values       | Default     |
|-------------|---------------------|----------------|-----------------------|-------------|
| id          | id of item          | String/Number  | —                     | —           |
| label       | label of item       | String         | —                     | —           |
| checked     | Whether or checked  | Boolean        | —                     | false       |
| disabled    | whether or disabled | Boolean        | —                     | false       |
| type        | type of item        | String         | group                 | -           |

### Events

| Name         | Description                       | Parameters |
|--------------|-----------------------------------|------------|
| click        | fire when checked value clicked.  | event      |
| change       | fire when checked value changed.  | event      |

</docs>

<template>
  <div class="mt-radio-button" :class=" type ? `mt-radio-button--${type}` : ''">
    <input type="radio"
      :id="id"
      :checked="checked"
      :name="type"
      :disabled="disabled"
      @click="handleClick"
      @change="handleChange" />
    <label :for="id">
      <span class="line"></span>
      <span class="label">
        <slot></slot>
        <template v-if="!$slots.default">{{label}}</template>
      </span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'mt-radio-button',
  props: {
    type: {
      type: String,
    },
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
    },
    id: [String, Number],
  },
  components: {

  },
  data () {
    return {

    }
  },
  computed: {

  },

  methods: {
    handleClick(evt) {
      this.$emit('click', evt);
    },
    handleChange(evt) {
      this.$emit('change', evt);
    },
  },

}
</script>
<style src="./RadioButton.scss" lang="scss">
</style>



// WEBPACK FOOTER //
// RadioButton.vue?75a3a470